import { useEffect, useState, useRef, FC } from "react";
import { CiLocationOn } from "react-icons/ci";
import { Like, onestar, tesla } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import { VehicleType } from "../../types";
import Loading from "../loading/Loading";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { HiDotsHorizontal, HiDotsVertical } from "react-icons/hi";
import useOutsideClick from "../../hooks/useOutsideClick";
import { useDispatch } from "react-redux";
import {
  setVehicleToEdit,
  setIsChangePlan,
} from "../../redux/slices/vehicleFilterSlice";

type VehicleCardProps = {
  vehicle: VehicleType;
};

const ListedCard: FC<VehicleCardProps> = ({ vehicle }) => {
  const navigate = useNavigate();

  const [isHover, setIsHover] = useState<boolean>(false);

  const optionsRef = useRef<HTMLDivElement | null>(null);
  useOutsideClick(optionsRef, () => {
    setIsHover(false);
  });

  const [loading, setLoading] = useState<boolean>(false);
  const [images, setImages] = useState<string[]>([]);

  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);

    if (vehicle.carImages[0]) {
      // const images = splitStringByComma(vehicle?.carImages[0]?.imageUrl);
      const imgArr = vehicle?.carImages
        ?.filter((image) => image.imageUrl)
        .map((image) => image.imageUrl);
      // const imgMap = imgArr.map((image) => image.imageUrl);
      const imgArrs = new Set(imgArr);

      // console.log(images);
      setImages(Array.from(imgArrs));
    }

    setLoading(false);
  }, [vehicle?.carImages]);

  if (loading) return <Loading loading={loading} />;

  return (
    <div className="bg-white shadow-2xl  w-[320px] flex flex-col gap-3 pb-4 ">
      <div className="border-b  border-greyText text-[#656575] p-5 font-Inter font-medium text-lg flex justify-between items-center ">
        <span className=" font-Jakarta font-medium text-sm text-greyText">
          #{vehicle?.id.substring(0, 10)}...
        </span>
        <span
          className="cursor-pointer relative  ml-auto"
          onClick={() => {
            setIsHover(!isHover);
          }}
        >
          {" "}
          {isHover ? (
            <HiDotsVertical size={20} />
          ) : (
            <HiDotsHorizontal size={20} />
          )}
          {isHover && (
            <div
              ref={optionsRef}
              className="absolute w-[150px] top-0 left-10 z-50 bg-white shadow-lg rounded-lg p-2"
            >
              <ul className="flex flex-col gap-2 p-3">
                <li
                  onClick={() => dispatch(setVehicleToEdit(vehicle))}
                  className=" text-[#535356] hover:text-[#ff276a] font-Inter text-sm font-normal "
                >
                  Edit Vehicle
                </li>
                <li
                  onClick={() =>
                    dispatch(
                      setIsChangePlan({
                        carId: vehicle.id,
                        planId: vehicle.plan.id ?? "c",
                      })
                    )
                  }
                  className=" text-[#535356] hover:text-[#ff276a] font-Inter text-sm font-normal "
                >
                  Change Plan
                </li>
                <li className=" text-[#535356] hover:text-[#ff276a] font-Inter text-sm font-normal ">
                  Disable Vehicle
                </li>
              </ul>
            </div>
          )}
        </span>
      </div>
      <div className="relative w-full h-[150px] p-1 md:p-4  ">
        {images?.length > 0 && (
          <img
            src={ipfsGatewayImage(images[0])}
            alt=""
            className="w-full h-full object-cover border rounded-md"
          />
        )}
        {/* <img src={Like} alt="" className="absolute top-0 right-0 p-4" /> */}
      </div>
      <div className="flex justify-between px-1 md:px-4 lg:px-6">
        <div className="flex flex-col gap-2 w-2/3 md:w-1/2">
          <h3 className=" font-Jakarta text-[12px] lg:text-[18px] leading-6 font-bold text-[#1a202c] ">
            {vehicle?.make} {vehicle?.model} {""}
          </h3>
          <p className="flex gap-1 items-center  text-[#90acbf] font-Poppins text-[8px] lg:text-[10px] font-normal ">
            <img src={onestar} alt="" />
            {vehicle.carRatings.length > 0
              ? vehicle?.carRatings.reduce((a, b) => a + b.meanRating, 0) /
                vehicle?.carRatings.length
              : 0}
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <h3 className="text-[#000] font-Jakarta text-[11px] lg:text-lg font-bold text-right">
            ${vehicle?.pricePerHour}/{" "}
            <span className="font-Jakarta text-[#90a3bf] text-[7px] lg:text-[13px] font-bold">
              day
            </span>
          </h3>
          {/* <p className="flex gap-2 text-[#90a3bf] font-Jakarta font-medium text-[8px] lg:text-[10px] border border-[#90a3bf] rounded-3xl p-1 items-center">
            <CiLocationOn size={15} color="darkGreen" />
            {vehicle?.distance}
            50.3 miles away
          </p> */}
        </div>
      </div>
      {/* <div className="mx-auto bg-darkGreen flex items-center justify-center w-5/6 border rounded-lg cursor-pointer text-white p-3 ">
        <button type="button">View Details</button>
      </div> */}
    </div>
  );
};

export default ListedCard;
